import { Component } from '@angular/core';
import {IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ApiAuthProvider} from "../../providers/api-auth/api-auth";

/**
 * Generated class for the AppPasswordChangePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

class PasswordChangeItem {
  oldPassword: string;
  newPassword: string;
  renewPassword: string;
}

@IonicPage()
@Component({
  selector: 'page-app-password-change',
  templateUrl: 'app-password-change.html',
})
export class AppPasswordChangePage {

  errorVisible: boolean = false;
  item: PasswordChangeItem;
  customError: string;
  constructor(public navCtrl: NavController, public navParams: NavParams, private apiAuth: ApiAuthProvider, private loadingController: LoadingController) {
    this.item = new PasswordChangeItem();
  }

  hideError() {
    this.errorVisible = false;
    this.customError = '';
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppPasswordChangePage');
  }

  verifyData() {
    if(this.item.newPassword != this.item.renewPassword) {
      this.item.renewPassword = '';
      this.customError = 'New and Renew password not the same';
      this.errorVisible = true;
      return;
    }

    if(!this.item.newPassword || this.item.newPassword.length < 6) {
      this.customError = 'New password too short';
      this.errorVisible = true;
      return;
    }
    if(!this.item.oldPassword) {
      this.customError = 'Incorrect old password';
      this.errorVisible = true;
      return;
    }

    var loading = this.loadingController.create({})
    loading.present();

    this.apiAuth.passwordUpdate(this.item.oldPassword, this.item.newPassword).then(() => {
      loading.dismissAll();
      this.navCtrl.pop();
    }).catch(() => {
      loading.dismissAll();
      this.customError = 'Incorrect old password';
      this.errorVisible = true;
      return;
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-password-change/app-password-change.ts